import { NotificationBannerConfig } from '../../../../domain/chat/models/NotificationBanner';
import { BaseService } from '../../../http/BaseHttpService';
import { buildProGPTUrl } from '../../../../features/utils/buildProGPTUrl';

export class ProGPTSettingsService extends BaseService {
    private readonly baseUrl: string;

    constructor(baseUrl: string) {
        super();
        this.baseUrl = baseUrl;
    }

    public async getAnnouncementConfigAsync(accessToken: string): Promise<NotificationBannerConfig> {
        return await this.getResponseAsync<NotificationBannerConfig>(
            {
                url: buildProGPTUrl(this.baseUrl, '/settings/announcement'),
                method: 'GET',
            },
            accessToken,
        );
    }
}
